<template>
  <div class="container-fluid pt-0 mt-0">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>

    <EditPartner
      v-if="showModal"
      mode="add"
      :show="showModal"
      v-on:closeEditPartnerModal="closeModal"
      @showSuccessPopup="handleSuccessPopup"
    />

    <EditPartner
      v-if="editPartnerModal"
      mode="edit"
      :show="editPartnerModal"
      :partner="editedPartner"
      v-on:closeEditPartnerModal="editPartnerModal = false"
      @showSuccessPopup="handleSuccessPopup"
    />

    <DeleteModal
      :show="showDelete"
      @close="closeDelete"
      :name="$t('partner')"
      @submit="doDelete"
    />

    <SuccessModal
      :show="showSuccessPopup"
      @close="showSuccessPopup = false"
      :msg="successMsg"
      :heading="successHeading"
    />
<!-- 
    <AddPartner
      v-if="showModal"
      :show="showModal"
      @close-modal="closeModal"
      :onCancel="closeModal"
    /> -->

    <div
      style="
          background-color: #fff;
          max-height: 40rem;
          overflow-y: auto;
          width: 100%;
          height: fit-content;
        "
    >
      <div class="card-body" style="overflow-x: auto; width: 100%">
        <div class="header d-flex justify-content-between align-items-center">
          <p>{{ $t("partners") }}</p>
          <TableSearch @handleSearch="handleSearch" />
        </div>

        <div class="row">
          <div class="col-md-12">
            <div ref="content" class="table-responsive">
              <table id="order-listing" class="table table-hover display">
                <thead style="background-color: rgba(240, 244, 251, 0.6)">
                  <tr>
                    <th
                      :key="index"
                      v-for="(column, index) in tableColumns"
                      @click="sortBy(column[1])"
                      style="cursor: pointer; text-align: left"
                    >
                      {{ column[0] }}
                      <span
                        class="arrow"
                        :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                      ></span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    :key="index"
                    v-for="(partner, index) in paginatedData"
                    class="user-row"
                    style="border-bottom: unset"
                    :class="{
                      'data-table-bg': index % 2 !== 0,
                    }"
                  >
                    <td>{{ partner.name }}</td>
                    <td>{{ partner.email }}</td>

                    <td>{{ partner.phoneNumber }}</td>

                    <td>{{ partner.address }}</td>
                    <td>
                      <div class="d-flex align-items-center col-gap-1">
                        <span
                          class="cursor-pointer"
                          @click="editpartner(partner)"
                        >
                          <IconEdit />
                        </span>
                        <span class="cursor-pointer" @click="openDelete(partner.id)">
                          <IconDelete />
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Pagination
              :pageCount="pageCount"
              :data="paginatedData"
              :sizeperpage="sizeperpage"
              :pageNumber="pageNumber"
              :pages="pages"
              @goToLastPage="goToLastPage"
              @nextPage="nextPage"
              @handlePageChange="handlePageChange"
              @goToFirstPage="goToFirstPage"
              @prevPage="prevPage"
              @onchange="onchange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "intro.js/introjs.css";

//   import AddDispatchContact from "../../views/Modals/AddDispatchContact.vue";
//   import EditContact from "../Modals/EditContact";
import IconEdit from "../../components/Iconsvg/IconEditUser.vue";
import IconDelete from "../../components/Iconsvg/IconDeleteUser.vue";
import tableMixin from "../../mixins/tableMixinWithBackend";
import Pagination from "../../components/PaginationNew.vue";
import TableSearch from "../../components/TableSearch.vue";
import SuccessModal from "../Modals/SuccessModal.vue";
import DeleteModal from "../Modals/DeleteModal.vue";

// import AddPartner from "../Modals/AddPartner.vue";
import EditPartner from "../Modals/EditPartner.vue";
import AddPartner from "../Modals/AddPartner.vue";

export default {
  name: "DispatchPartners",
  components: {
    Loading,
    IconEdit,
    IconDelete,
    Pagination,
    TableSearch,
    SuccessModal,
    DeleteModal,

    // AddPartner,
    EditPartner,
  },
  data() {
    return {
      isLoading: true,

      fullPage: true,
      showSuccessPopup: false,
      showDelete: false,
      dataTable: [],

      successMsg: "",
      successHeading: "",

      editPartnerModal: false,

      editedPartner: [],

      Tag: "",

      // showModal: true

      // localShowModal: this.showModal
    };
  },
  mounted() {
    this.fetchPartners(this.params);
  },
  mixins: [tableMixin],
  props: {
    showModal: Boolean,
    closeModal: Function,
  },
  computed: {
    ...mapGetters(["partners", "meta"]),
    paginationMeta() {
      return this.meta;
    },
    tableColumns() {
      return [
        [this.$t("company-name"), "fullname"],
        [this.$t("emailModal.emailAddress"), "email"],
        [this.$t("phone_num"), "phonenumber"],
        [this.$t("company-address"), "email"],
        [this.$t("action"), "column2"],
      ];
    },
  },
  methods: {
    ...mapActions(["getPartner", "deletePartner"]),
    handleSuccessPopup({ msg, heading }) {
      this.successMsg = msg;
      this.successHeading = heading;
      this.showSuccessPopup = true;
    },
    editpartner(partnerInfo) {
      console.log(partnerInfo);

      this.editPartnerModal = true;

      // this.showModal= false

      this.editedPartner = [partnerInfo];
      this.Tag = "";
      console.log(this.editedPartner);
    },
    closeDelete() {
      this.id = "";
      this.showDelete = false;
    },
    openDelete(id) {
      this.showDelete = true;
      this.id = id;
    },
    doDelete() {
      this.isLoading = true;
      this.deletePartner(this.id).then(() => {
        this.getPartner();
        this.isLoading = false;
        this.showDelete = false;

        this.showSuccessPopup = true;

        this.successMsg = this.$t("deleted_contact_mssg");
        this.successHeading = this.$t("deleted_contact_heading");
      });
    },
    doSearch() {
      let params = {
        ...this.params,
        name: this.searchQuery,
      };
      this.fetchPartners(params);
    },
    fetchPartners(params) {
      this.isLoading = true;
      this.getPartner(params)
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    partners: {
      handler: function() {
        this.dataTable = this.partners;
      },
      deep: true,
    },
    params() {
      this.fetchPartners(this.params);
    },
  },
};
</script>

<style scoped>
.header {
  margin-bottom: 1rem;
}

.header > p {
  font-size: 14px;
  font-weight: 700;
  line-height: 18.2px;
  color: rgba(64, 74, 87, 1);
  margin-top: 1rem;
}
</style>
